module.exports = __webpack_public_path__ + "static/media/dokify-logo-black.c110b801.svg";